import directive from './saas-loading-directive.js'
import service from './saas-loading-service.js'
export default {
    install(Vue) {
        Vue.use(directive);
        Vue.prototype.$loading = service;
    },
    directive,
    service
};
